import { FC } from 'react'
import formatEditDate from 'helpers/date/formatEditDate'
import { Tooltip, TooltipTrigger, TooltipContent } from '@wellesley/ui'

import { THeader } from '../types'

const EditedLabel: FC<Pick<THeader, 'feed'>> = ({ feed }) => (
  <Tooltip disableHoverableContent>
    <TooltipTrigger data-testid="header-edited-tag" asChild>
      <button
        className="cursor-default"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        edited
      </button>
    </TooltipTrigger>
    <TooltipContent theme="dark" size="small" align="center">
      {formatEditDate(feed.updatedAt)}
    </TooltipContent>
  </Tooltip>
)

export default EditedLabel
